import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';
import { isProd } from '@agria/utils'; // Assuming this utility is correctly imported

export const ScriptsBefore = () => {
  const LOAD_LIVE_CHAT = process.env.GATSBY_LOAD_LIVE_CHAT === 'true';

  // Get the list of paths where live chat should be disabled
  const LIVE_CHAT_DISABLED_PATHS =
    process.env.GATSBY_LIVE_CHAT_DISABLED_PATHS || '';

  // Assuming LOAD_SURFLY would be defined similarly if Surfly's loading is also conditional
  // const LOAD_SURFLY = process.env.GATSBY_LOAD_SURFLY === 'true';

  return (
    <>
      {/* GTM */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PK9D66');
      `}
      </Script>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PK9D66"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="gtm-frame"
        />
      </noscript>

      {/* OneTrust Cookies Consent Notice */}
      <Script
        strategy={ScriptStrategy.postHydrate}
        type="text/javascript"
        src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        charSet="UTF-8"
        data-domain-script={`6838ac24-c4a1-49da-814b-86be451dcdeb${
          !isProd ? '-test' : ''
        }`}
      />
      <Script
        strategy={ScriptStrategy.postHydrate}
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: 'function OptanonWrapper() {}' }}
      />

      {/* TVSquared Tracking Code */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
        var _tvqsky = window._tvqsky = window._tvqsky || [];
        (function() {
        var u = (("https:" == document.location.protocol) ?
        "https://collector-31509.tvsquared.com/"
        :
        "http://collector-31509.tvsquared.com/");
        _tvqsky.push(['setSiteId', "TV-6381459009-1"]);
        _tvqsky.push(['setTrackerUrl', u + 'tv2track.php']);
        _tvqsky.push([function() {
        this.deleteCustomVariable(5, 'page')
        }]);
        _tvqsky.push(['trackPageView']);
        var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.defer = true;
        g.async = true;
        g.src = u + 'tv2tracksky.js';
        s.parentNode.insertBefore(g, s);
        })();
      `}
      </Script>

      {/* TV tracking (Adalyser) */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
        (function(clientId) {
          if(window["__adal_disable_" + clientId]) { return; }
          (function(windowAlias, documentAlias, trackerName) {
              if (!windowAlias[trackerName]) {
                  windowAlias.GlobalAdalyserNamespace = windowAlias.GlobalAdalyserNamespace
                          || [];
                  windowAlias.GlobalAdalyserNamespace.push(trackerName);
                  windowAlias[trackerName] = function() {
                      (windowAlias[trackerName].q = windowAlias[trackerName].q || []).push(arguments)
                  };
                  windowAlias[trackerName].q = windowAlias[trackerName].q || [];
                  var nel = documentAlias.createElement("script"),
                      fel = documentAlias.getElementsByTagName("script")[0];
                  nel.async = 1;
                  nel.src = "//c5.adalyser.com/adalyser.js?cid=" + clientId;
                  fel.parentNode.insertBefore(nel, fel)
              }
          }(window, document, "adalyserTracker"));
          window.adalyserTracker("create", {
              campaignCookieTimeout: 15552000,
              conversionCookieTimeout: 604800,
              clientId: clientId,
              trafficSourceInternalReferrers: [
                  "^(.*\\.)?agriapet\\.co\\.uk$"
              ]
          });
          window.adalyserTracker("trackSession", "lce1");
      })("agriapetinsurance");
      `}
      </Script>

      {/* Dax radio tracking */}
      <img
        src="https://tracking.audio.thisisdax.com/one.png?client=AgriaPets&action=cs&eventId=&event=JourneyAppe&j=0"
        width="0"
        height="0"
        style={{ display: 'none' }}
        alt=""
      />

      {/* Optimise */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       var OMID=1152041; var OPID=32478; var ORef=escape(window.parent.location.href); /* Added var */
       !function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,
       a.src="//track.omguk.com/e/qs/?action=Content&MID=" + OMID + "&PID=" + OPID + "&ref="+ ORef;
       var b=document.getElementsByTagName("body")[0];if(b)b.appendChild(a,b);
       else{var c=document.getElementsByTagName("script")[0];c.parentNode.insertBefore(a,c)}}(); /* Changed to c */
      `}
      </Script>

      {/* Pixel (AppNexus) */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       !function(e,i){if(!e.pixie){var n=e.pixie=function(e,i,a){n.actionQueue.push({action:e,actionValue:i,params:a})};n.actionQueue=[];var a=i.createElement("script");a.async=!0,a.src="//acdn.adnxs.com/dmp/up/pixie.js";var t=i.getElementsByTagName("head")[0];t.insertBefore(a,t.firstChild)}}(window,document);
       pixie('init', '4d07860b-0dfc-41a7-8244-3cebd93c414f');
      `}
      </Script>

      {/* Bing Ads */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[] ,f=function(){var o={ti:"17219122"}; o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")} ,n=d.createElement(t),n.src=r,n.async=1,n.onload=n .onreadystatechange=function() {var s=this.readyState;s &&s!=="loaded"&& s!=="complete"||(f(),n.onload=n. onreadystatechange=null)},i= d.getElementsByTagName(t)[0],i. parentNode.insertBefore(n,i)})(window,document,"script"," //bat.bing.com/bat.js","uetq");
      `}
      </Script>

      {/* Yieldify */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       (function(d){var e=d.createElement('script');e.src='https://td.yieldify.com/yieldify/code.js?w_uuid=a0bdcf52-49eb-4cfc-91a6-719c66e05ec0&k=1&loca='+encodeURIComponent(window.location.href);e.async=true;d.getElementsByTagName('head')[0].appendChild(e);}(document)); /* Added encodeURIComponent */
      `}
      </Script>

      {/* Smarter tracking */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
          (function (s, m, a, r, t) { s[r] = s[r] || []; var f = m.getElementsByTagName(a)[0], j = m.createElement(a), dl = r != 'dataLayer' ? '&r=' + r : ''; j.async = true; j.src = '//smct.co/tm/?t=' + t + dl; f.parentNode.insertBefore(j, f); }
          )(window, document, 'script', 'dataLayer', 'agriapet.co.uk');
       `}
      </Script>

      {/* Livechat (CXone) Integration */}
      {LOAD_LIVE_CHAT && (
        <Script
          strategy={ScriptStrategy.postHydrate}
          id="cxone-init-and-cobrowse-trigger"
        >
          {`
              // Check if live chat should be disabled for current path
              function shouldDisableLiveChatForCurrentPath() {
                const disabledPaths = '${LIVE_CHAT_DISABLED_PATHS}';
                
                if (!disabledPaths) {
                  return false;
                }
                
                const currentPath = window.location.pathname;
                const paths = disabledPaths.split(',').map(path => path.trim());
                
                return paths.some(disabledPath => {
                  if (disabledPath.endsWith('*')) {
                    return currentPath.startsWith(disabledPath.slice(0, -1));
                  }
                  return currentPath === disabledPath;
                });
              }

              // Function to show/hide chat using CSS
              function toggleChatVisibility() {
                const shouldHide = shouldDisableLiveChatForCurrentPath();
                
                // Get or create the style element
                let styleEl = document.getElementById('live-chat-visibility-style');
                if (!styleEl) {
                  styleEl = document.createElement('style');
                  styleEl.id = 'live-chat-visibility-style';
                  document.head.appendChild(styleEl);
                }
                
                if (shouldHide) {
                  console.log('Live Chat Debug - Hiding chat with CSS for path:', window.location.pathname);
                  styleEl.textContent = '#be-chat-container { display: none !important; }';
                } else {
                  console.log('Live Chat Debug - Showing chat for path:', window.location.pathname);
                  styleEl.textContent = '#be-chat-container { display: block !important; }';
                }
              }

              // Initial visibility check
              toggleChatVisibility();

              // Ensure this CXone initialization and event listener setup runs only once
              if (!window.cxoneGlobalSetupStarted) {
                window.cxoneGlobalSetupStarted = true;

                // 1. CXone Loader
                (function(n, u) {
                  window.CXoneDfo = n;
                  window[n] = window[n] || function() {
                    (window[n].q = window[n].q || []).push(arguments);
                  };
                  window[n].u = u;
                  
                  var loaderScriptId = 'cxone-loader-script';
                  if (!document.getElementById(loaderScriptId)) {
                    var e = document.createElement("script");
                    e.id = loaderScriptId;
                    e.type = "module";
                    e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600); // Cache-busting
                    document.head.appendChild(e);
                  }
                })('cxone', 'https://web-modules-de-uk1.niceincontact.com/loader/1/loader.js');

                // 2. Queue CXone Initialization Commands & Setup Cobrowse Listener
                function setupCxOneInteractions() {
                  try {
                    // Queue CXone initialization commands
                    cxone('init', '1332');
                    cxone('chat', 'init', 1332, 'chat_1c365a59-2701-4e39-bab9-bfb996282be0');
                    // Allow specific message types, crucial for receiving the #COBRO# message
                    cxone('chat', 'setAllowedExternalMessageTypes', ['MESSAGE_SENT', 'MESSAGE_RECEIVED']);

                    // 3. Add Cobrowse Trigger Event Listener (if not already added)
                    if (!window.cxoneCobrowseMessageListenerAdded) {
                      window.addEventListener("message", function(event) {
                        // Basic validation of the event structure
                        if (event.data && 
                            event.data.actionType === "MESSAGE_RECEIVED" && 
                            event.data.action && 
                            typeof event.data.action.message === 'string') {
                          
                          const messageContent = event.data.action.message;
                          
                          if (messageContent.trim() === "#COBRO#") {
                            
                            if (typeof window.startSurflySession === 'function') {
                              // Call the globally available Surfly session starter function
                              window.startSurflySession(
                                function(pin) { // pinCallback
                                  // TODO: Implement sending PIN back to chat agent if needed and CXone supports it.
                                  // Example: cxone('chat', 'sendMessage', 'Your Surfly Co-browse PIN is: ' + pin);
                                },
                                function() { // sessionEndCallback
                                },
                                function(error) { // errorCallback
                                  console.error("CXone Live Chat via Surfly: Error during Surfly session:", error);
                                }
                              );
                            } else {
                              console.warn("CXone Live Chat: Surfly function 'window.startSurflySession' not found. CoBrowse cannot be initiated. Ensure Surfly script (if used) is loaded and initialized correctly.");
                            }
                          }
                        }
                      });
                      window.cxoneCobrowseMessageListenerAdded = true;
                    }
                  } catch (error) {
                    console.error('CXone Live Chat: Error during setupCxOneInteractions:', error);
                  }
                }

                // The CXone loader pattern queues commands if 'cxone' isn't ready.
                setupCxOneInteractions();

                // Set up route change listener for SPA navigation
                let lastUrl = location.href;
                new MutationObserver(() => {
                  const url = location.href;
                  if (url !== lastUrl) {
                    lastUrl = url;
                    console.log('Live Chat Debug - Route changed to:', window.location.pathname);
                    // Wait a bit for the page to settle, then toggle visibility
                    setTimeout(toggleChatVisibility, 100);
                  }
                }).observe(document, { subtree: true, childList: true });

                // Also listen for popstate events (back/forward navigation)
                window.addEventListener('popstate', function() {
                  console.log('Live Chat Debug - Popstate event, checking path');
                  setTimeout(toggleChatVisibility, 100);
                });
              }
            `}
        </Script>
      )}
    </>
  );
};
